export const checkFetchingData = (state) => {
  return Object.values(state).some(({ fetchingData, fetchingMatches }) => fetchingData || fetchingMatches);
};
